// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2061":"ab6dcbde","3575":"ce044c50","4262":"ab6dcbde","4935":"08d55499","5325":"ab6dcbde","6782":"ab6dcbde"}[chunkId] + ".chunk.css";
};